import { useEffect, useState } from "react";
import "./Contactus.css";
import MapSection from "../home/partials/MapSection";
import ContactForm from "./partials/ContactForm";
import ContactDetails from "./partials/ContactDetails";
import api from "../../services/api";

const Contactus = () => {
    const [footerData, setFooterData] = useState(null);

    useEffect(() => {
        api.get("/api/global/footer-contact")
            .then((response) => {
                setFooterData(response.data.footer_data);
            })
            .catch((error) => {
                console.error("API Error:", error);
            });
    }, []);

    if (!footerData) return null;

    return (
        <>
        <section className="contactus-section pt-5 pb-0">
            <div className="container">
                <div className="row pb-3">
                    <div className="col-lg-6">
                        <div className="text-center">
                            <h2 className="section-title">Contact Us</h2>
                            <p className="section-subtitle">Let’s Get in Touch</p>
                        </div>
                        <ContactForm />
                    </div>
                    <div className="col-lg-6 mt-3 mt-lg-0">
                        <div className="contact-image-wrapper">
                            <img src="/assets/img/contact-us.webp" alt="contact" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>

            <ContactDetails 
                address1={footerData.address_line_1}
                address2={footerData.address_line_2}
                email={footerData.email}
                phones={footerData.phone_numbers}
            />

            <MapSection />
        </section>
        </>
    );
};

export default Contactus;
